@if (isDepositValidationInProgress()) {
    <p class="pt-10 text-sm font-normal text-custom-extra-dark-grey">
        {{ 'depositValidateInProgress' | transloco }}
    </p>
} @else if (importErrorMessage(); as message) {
    <div class="pt-8 min-w-0 max-w-full">
        <div class="flex justify-center">
            <fa-icon
                class="text-error shrink-0"
                size="2x"
                [icon]="['fas', 'warning']" />
        </div>

        <p class="text-sm font-medium text-error pt-3 text-left whitespace-pre-line break-words">
            {{ message }}
        </p>

        <p class="text-sm font-normal text-custom-extra-dark-grey pt-3 text-left break-words">
            {{ 'depositWillBeReplaced' | transloco }}
        </p>
    </div>
} @else if (hasValidationErrors()) {
    @if (deposit(); as currentDeposit) {
        <app-deposit-validation-errors
            [columnErrors]="columnErrors()"
            [deposit]="currentDeposit"
            [tableDuplicates]="tableDuplicates()"
            [tableErrors]="tableErrors()"
            (relaunch)="relaunchValidation()" />
    }
} @else if (deposit()?.status === Deposit.StatusEnum.ERRORED) {
    <div class="pt-8 min-w-0 max-w-full">
        <div class="flex justify-center">
            <fa-icon
                class="text-on-surface shrink-0"
                size="2x"
                [icon]="['fas', 'warning']" />
        </div>

        <p class="text-sm font-normal text-custom-extra-dark-grey pt-3 text-left break-words">
            {{ 'dataPreparationError' | transloco }}
        </p>
    </div>
} @else {
    <p class="pt-10 text-sm font-normal text-custom-extra-dark-grey break-words">
        {{ 'noErrorOnDeposit' | transloco }}
    </p>
}
@if (!deposit()?.hadDataAtImport) {
    <p class="pt-10 text-sm font-normal text-custom-extra-dark-grey break-words">
        {{ 'noDataImport' | transloco }}
    </p>
}

<app-expansion-panel>
    <div
        class="flex flex-row min-w-0 gap-2 items-baseline"
        header>
        <span class="font-medium text-xl items-center min-w-0 break-words">
            {{
                'layersCreated'
                    | transloco
                        : {
                              COUNT: createDepositLayerService.createdTables().length,
                          }
            }}
        </span>

        <span class="shrink-0"> ({{ createDepositLayerService.createdTables().length }}) </span>
    </div>

    <div
        class="min-w-0 max-w-full"
        content>
        @for (table of createDepositLayerService.createdTables(); track table.name) {
            <p class="break-words">
                {{ table.name }}
            </p>
        } @empty {
            <span class="text-outline font-normal break-words">
                {{ 'noLayerCreated' | transloco }}
            </span>
        }
    </div>
</app-expansion-panel>
